export default "__VITE_ASSET__BmpzpnkS__"